import React, { useState } from "react";
import { Form, Input, Button, Typography, Row, Col, Result } from "antd";
import { MailOutlined } from "@ant-design/icons";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "../Login.css";

const { Title, Text } = Typography;

const Forgotpassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!email) return toast.error("Please enter your email");
    setLoading(true);
    try {
      await axios.post(`${base_url}user/forgot-password-token`, { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const backgroundImageUrl = `${process.env.PUBLIC_URL}/admin-login.png`;

  return (
    <Row style={{ minHeight: "100vh" }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Col
        xs={0} sm={0} md={12}
        style={{
          background: `url(${backgroundImageUrl}) no-repeat center center`,
          backgroundSize: "cover",
        }}
      />
      <Col xs={24} sm={24} md={12} className="right-block">
        <div className="login-card">
          <div className="login-card-accent" />

          <div className="text-center" style={{ marginBottom: 12 }}>
            <img
              src={`${process.env.PUBLIC_URL}/LNG_SKILLS_LOGO.png`}
              alt="LNJ Skills"
              style={{ width: 64, height: 56, objectFit: "contain" }}
            />
          </div>

          {!sent ? (
            <>
              <Title level={3} className="text-center" style={{ marginBottom: 4 }}>
                Forgot Password
              </Title>
              <Text className="text-center login-subtitle" type="secondary">
                Enter your email and we'll send you a reset link
              </Text>

              <Form layout="vertical" onFinish={handleSubmit}>
                <Form.Item label="Email Address">
                  <Input
                    prefix={<MailOutlined style={{ color: "#4f46e5" }} />}
                    type="email"
                    placeholder="Enter your registered email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onPressEnter={handleSubmit}
                  />
                </Form.Item>

                <Button
                  type="primary"
                  block
                  loading={loading}
                  onClick={handleSubmit}
                  style={{ marginBottom: 8 }}
                >
                  Send Reset Link
                </Button>

                <div style={{ textAlign: "center", marginTop: 12 }}>
                  <Button type="link" onClick={() => navigate("/")}>
                    ← Back to Login
                  </Button>
                </div>
              </Form>
            </>
          ) : (
            <Result
              status="success"
              title="Check your email"
              subTitle={
                <span>
                  We've sent a password reset link to <strong>{email}</strong>.
                  <br />
                  The link is valid for <strong>30 minutes</strong>.
                </span>
              }
              extra={[
                <Button type="primary" key="login" onClick={() => navigate("/")}>
                  Back to Login
                </Button>,
                <Button key="resend" onClick={() => { setSent(false); }} style={{ marginTop: 8 }}>
                  Resend Link
                </Button>,
              ]}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default Forgotpassword;
